import { DisabledPrompt, Link, useStateManager } from "@bcm-dev/bcms-vite";
import { TableBody, TableColumnContainer, TableColumnView, TableItemContainer, TableItemTextView, TableItemView, TableView } from 'components/shared';
import React from 'react';
import { SVGAsset } from 'res';

/**
 * @function WirePayeesTable
 * @return {React.Component}
 * @exported true
 * @description The table to shows the wire payees
 */

export default function WirePayeesTable(props) {
  const payees = props.payees ?? [];

  const payeeRows = payees.reduce((acc, payee) => {
    acc.push(<WirePayeesRow key={ payee.id } payee={ payee } />);
    return acc;
  }, []);
  
  return(
    <TableView className="wire-payees-table">
      <TableColumnContainer>
        <TableColumnView className="text-left" text=
          {<>Nickname
            <DisabledPrompt>
              <SVGAsset className="clickable" id="ArrowUpIcon" />
            </DisabledPrompt>
          </>} 
        />
        <TableColumnView className="text-left" text=
          {<>Payee Name
            <DisabledPrompt>
              <SVGAsset className="clickable" id="SortIcon" />
            </DisabledPrompt>
          </>} 
        />
        <TableColumnView className="text-left" text=
          {<>Account Number
            <DisabledPrompt>
              <SVGAsset className="clickable" id="SortIcon" />
            </DisabledPrompt>
          </>} 
        />
        <TableColumnView />
        <TableColumnView />
      </TableColumnContainer>
      <TableBody>
        { payeeRows }
      </TableBody>
    </TableView>
  );
}

/**
 * @function WirePayeesRow
 * @return {React.Component}
 * @exported false
 * @description The table row that display the wire payee
 */

function WirePayeesRow(props) {
  const { data, editPayee } = useStateManager();
  const payee =  props.payee ?? {};
  const dataPointNickname = payee.id ? { "data-point": `Wire_Payees_Row_Nickname_${ payee.id }` } : {};
  const dataPointName = payee.id ? { "data-point": `Wire_Payees_Row_Name_${ payee.id }` } : {};
  const dataPointAccountNumber = payee.id ? { "data-point": `Wire_Payees_Row_Account_Number_${ payee.id }` } : {};
  const dataPointEditIcon = payee.id ? { "data-point": `Wire_Payees_Row_Edit_Icon_${ payee.id }` } : {};
  const dataPointDeleteIcon = payee.id ? { "data-point": `Wire_Payees_Row_Delete_Icon_${ payee.id }` } : {};

  return(
    <TableItemContainer className="wire-payees-row">
      <TableItemTextView text={ payee.nickname } { ...dataPointNickname } />
      <TableItemTextView text={ payee.name } { ...dataPointName } />
      <TableItemTextView text={ payee.account } { ...dataPointAccountNumber } />
      <TableItemView>
        <Link onClick={ editPayee(payee.id) }>
          <SVGAsset { ...dataPointEditIcon } id="PencilIcon" />
        </Link>
      </TableItemView>
      <TableItemView>
        <DisabledPrompt>
          <SVGAsset { ...dataPointDeleteIcon } id="TrashcanXIcon" className="clickable"/>
        </DisabledPrompt>
      </TableItemView>
    </TableItemContainer>
  );
}